import i18n from '@/utils/i18n';
import React from 'react';
import { ShimmerText } from '@usepepper/sprout-kit-ui';

interface AgentThinkingIndicatorProps {
  label?: string;
}

export const AgentThinkingIndicator: React.FC<AgentThinkingIndicatorProps> = ({
  label = i18n.t('sales_portal.superintelligence.thinking'),
}) => (
  <ShimmerText
    color="$textSecondary"
    loadingLabel={label}
    numberOfLines={1}
    size="$sm"
  >
    {label}
  </ShimmerText>
);
